import { RootState } from '@src/redux/store'
import { prop } from 'ramda'
import { createSelector } from 'reselect'

import { GLOBAL_STATE, RECRUITMENT_INQUIRY_LIST } from '../constants/actionTypes'

const recruitmentInquirySelector = (state: RootState) => prop(GLOBAL_STATE, state)

export const recruitmentInquiryListSelector = createSelector(
  recruitmentInquirySelector,
  data => data[RECRUITMENT_INQUIRY_LIST]
)
